(() => {
  if (window.ICTCoffeeViewToggleLoaded) return;
  window.ICTCoffeeViewToggleLoaded = true;

  const STORAGE_KEY = 'ict-coffee-collection-view';
  const VALID_VIEWS = ['cards', 'list'];

  function readStoredView() {
    try {
      const storedView = window.localStorage.getItem(STORAGE_KEY);
      return VALID_VIEWS.includes(storedView) ? storedView : 'cards';
    } catch (error) {
      return 'cards';
    }
  }

  function storeView(view) {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      // The toggle still works if storage is unavailable.
    }
  }

  function applyView(collectionComponent, view, persist = false) {
    if (!collectionComponent || !VALID_VIEWS.includes(view)) return;

    const grid = collectionComponent.querySelector('[data-ict-product-grid]');
    const buttons = collectionComponent.querySelectorAll('[data-ict-view]');

    if (!grid || buttons.length === 0) return;

    grid.classList.toggle('ict-view--cards', view === 'cards');
    grid.classList.toggle('ict-view--list', view === 'list');
    grid.dataset.ictCurrentView = view;
    collectionComponent.classList.toggle('ict-collection--cards', view === 'cards');
    collectionComponent.classList.toggle('ict-collection--list', view === 'list');

    buttons.forEach((button) => {
      const isActive = button.dataset.ictView === view;
      button.setAttribute('aria-pressed', String(isActive));
    });

    if (persist) storeView(view);
  }

  function initializeCollection(collectionComponent) {
    if (!collectionComponent) return;

    const grid = collectionComponent.querySelector('[data-ict-product-grid]');
    if (!grid) return;

    const currentView = grid.dataset.ictCurrentView || readStoredView();
    applyView(collectionComponent, currentView);
  }

  function initializeWithin(root = document) {
    if (root.matches && root.matches('collection-component')) {
      initializeCollection(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('collection-component').forEach(initializeCollection);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ict-view]');
    if (!button) return;

    const collectionComponent = button.closest('collection-component');
    applyView(collectionComponent, button.dataset.ictView, true);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initializeWithin(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initializeWithin(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeWithin(event.target);
  });
})();